var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({attrs:{"autocomplete":_vm.autocomplete,"pattern":_vm.pattern,"placeholder":"A0A 0A0","type":"text"},domProps:{"value":_vm.formattedValue},on:{"input":_vm.handleInput,"invalid":_vm.handleInvalid}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }